import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const CryptoTaxCompliancePage = lazy(() => import('../pages/crypto-tax-compliance/page'));
const SellCryptoPage = lazy(() => import('../pages/sell-crypto/page'));
const MaterialsPage = lazy(() => import('../pages/materials/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Admin Pages
const AdminLayout = lazy(() => import('../pages/admin/AdminLayout'));
const LoginPage = lazy(() => import('../pages/admin/LoginPage'));
const DashboardPage = lazy(() => import('../pages/admin/DashboardPage'));
const TransactionsPage = lazy(() => import('../pages/admin/TransactionsPage'));
const PaymentsPage = lazy(() => import('../pages/admin/PaymentsPage')); // New Page
const BookingsPage = lazy(() => import('../pages/admin/BookingsPage'));
const MaterialsAdminPage = lazy(() => import('../pages/admin/MaterialsPage')); // New Page
const AuditPage = lazy(() => import('../pages/admin/AuditPage'));

const routes: RouteObject[] = [
  {
    path: '/admin/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'payments', element: <PaymentsPage /> }, // New Route
      { path: 'transactions', element: <TransactionsPage /> },
      { path: 'bookings', element: <BookingsPage /> },
      { path: 'materials', element: <MaterialsAdminPage /> }, // New Route
      { path: 'audit', element: <AuditPage /> },
      { path: '', element: <Navigate to="dashboard" replace /> }
    ]

  },
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/consultation',
    element: <ConsultationPage />,
  },
  {
    path: '/crypto-tax-compliance',
    element: <CryptoTaxCompliancePage />,
  },
  {
    path: '/sell-crypto',
    element: <SellCryptoPage />,
  },
  {
    path: '/materials',
    element: <MaterialsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
